
import TruncateParagraph from '../atom/TruncateParagraph.vue';
export default {
  name: 'TickerSearchCard',
  components: {
    TruncateParagraph,
  },
  props: {
    ticker: {
      type: Object,
      required: true,
    },
  },
};
